import { StyleSheet } from '@react-pdf/renderer'
import { mainColor, UNIT } from '../../constants'

export const styles = StyleSheet.create({
    body: {
        paddingTop: 1.875 * UNIT,
        paddingLeft: 1.25 * UNIT,
        paddingRight: 1.25 * UNIT,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        paddingBottom: 2 * UNIT
    },
    title: {
        fontSize: 26,
        textAlign: 'center',
        marginBottom: 1.5 * UNIT
    },
    rightPart: { width: '38%', marginHorizontal: UNIT * 0.375 },
    leftPart: { width: '60%' },
    totalStyle: {
        fontSize: 0.625 * UNIT
    },

    author: {
        fontSize: 0.75 * UNIT,
        textAlign: 'center',
        marginBottom: 2.5 * UNIT
    },
    presdishop: {
        fontSize: 0.75 * UNIT,
        marginBottom: UNIT * 0.125
    },
    text: {
        fontSize: 0.625 * UNIT,
        marginBottom: UNIT * 0.125
    },
    nameUs: {
        marginBottom: 0.875 * UNIT,
        fontSize: 1.5 * UNIT
    },
    nameBuis: {
        marginBottom: 0.25 * UNIT,
        fontSize: 0.9375 * UNIT
    },
    companies: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginBottom: 0.625 * UNIT,
        paddingHorizontal: 0.9375 * UNIT
    },
    ref: {
        marginBottom: 0.625 * UNIT
    },
    tableau: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: 1.5 * UNIT,
        paddingHorizontal: 0.625 * UNIT,
        alignItems: 'center'
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: 1.75 * UNIT,
        paddingHorizontal: 0.625 * UNIT,
        alignItems: 'center'
    },
    rowDetail: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        paddingHorizontal: 0.625 * UNIT
    },

    tabValue: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 0.9375 * UNIT,
        marginBottom: 0.9375 * UNIT
    },
    rowPosition: {
        paddingTop: 3
    },
    underTab: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: UNIT * 2.187,
        paddingHorizontal: 0.625 * UNIT
    },
    separator: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: UNIT * 0.125,
        paddingHorizontal: 0.625 * UNIT
    },
    border: {
        borderBottom: '1 solid grey',
        marginBottom: UNIT * 0.3125,
        paddingBottom: UNIT * 0.5
    },
    topBorder: {
        borderTop: '1 solid grey',
        paddingTop: UNIT * 0.25
    },
    titleTab: {
        fontSize: 0.75 * UNIT
    },
    labelTab: {
        fontSize: 0.625 * UNIT
    },
    deliveryLabel: {
        fontSize: 0.625 * UNIT,
        margin: '3px 0'
    },
    margin: {
        marginTop: 5
    },
    totalLabel: {
        fontSize: 0.625 * UNIT,
        maxWidth: 6.75 * UNIT,
        flexWrap: 'wrap',

    },
    boldText: {
        fontWeight: 'bold'
    },
    underLabel: {
        fontSize: UNIT * 0.5
    },
    positionTab: {
        marginTop: 0.9375 * UNIT,
        marginBottom: 0.9375 * UNIT,
        height: '60%',
        marginHorizontal: 0.9375 * UNIT
    },
    positionTab2: {
        height: '80%',
        marginHorizontal: 0.9375 * UNIT
    },
    positionTabValue: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 0.9375 * UNIT,
        width: '100%'
    },
    firstTabValue: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 0.9375 * UNIT
    },
    positionRow: {
        display: 'flex',
        flexDirection: 'row'
    },
    obligationView: {
        fontSize: 10,
        marginTop: 2 * UNIT
    },
    tvaText: {
        marginBottom: 1
    },
    link: {
        marginLeft: 0.9375 * UNIT
    },
    bottomPage: {
        fontSize: 11,
        marginBottom: 0.5 * UNIT,
        marginHorizontal: 0.9375 * UNIT
    },
    image: {
        height: 25 * UNIT,
        width: 25 * UNIT
    },
    contract: {
        marginTop: UNIT * 0.3125
    },
    tableStyle: {
        paddingTop: UNIT * 0.3125
    },
    textStyle: {
        marginBottom: UNIT * 0.5
    },
    titleContract: {
        width: 13.125 * UNIT,
        height: 1.875 * UNIT,
        paddingLeft: 0.625 * UNIT
    },
    titleTextContract: {
        fontSize: UNIT
    },
    underlinedText: { textDecoration: 'underline' },
    rightHeader: {
        marginTop: 1.5 * UNIT,
        width: '40%',
        display: 'flex',
        alignItems: 'flex-end'
    },
    dangerColor: {
        color: mainColor.colorRed
    },
    alignementStyle: {
        paddingHorizontal: 0.9375 * UNIT
    },
    noInvoiceText: {
        fontSize: UNIT * 0.875,
        textAlign: 'center'
    }
});